export var DEPLOY_DATE = new Date('2026-10-08T19:30:17+0000');
